import { ExecuteEndpoint } from '../../components/common/BaseApiService';
import { GearIndex } from '../../Model/GearIndex';

export class IndexesService {
  public async getIndexes(): Promise<GearIndex[]> {
    return ExecuteEndpoint(`indexes`, 'GET');
  }
}
